import React, { useEffect, useMemo } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { ModalEntryPointContainer } from '@atlassian/jira-entry-point-modal-container';
import { ff } from '@atlassian/jira-feature-flagging';
import { useTriggerIssueTransitionModal } from '@atlassian/jira-issue-transition-trigger';
import { useSubscribeOpenIssueTransitionModalPubSub } from '@atlassian/jira-issue-transition-trigger/src/controllers/open-issue-transition-modal-pub-sub/use-subscribe-open-issue-transition-modal-pub-sub';
import { createAri } from '@atlassian/jira-platform-ari';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';
import type { Variables } from './types';
import { asyncIssueTransitionModal } from './ui/entrypoint';
import { useSiteContextARI } from './utils/site-ari';

const runtimeProps = {};
export const AsyncIssueTransitionModal = () => {
	const [{ isModalOpen, payload }] = useTriggerIssueTransitionModal();
	const { transitionId, issueId, issueKey } = payload;
	const siteContextARI = useSiteContextARI();
	/**
	 * Creating ari's which may be incorrect.
	 * This is not used in the query apart from verifying issueId,
	 */
	const cloudId = useCloudId();
	const defautIssueAri = createAri({
		resourceOwner: 'jira',
		cloudId,
		resourceType: 'issue',
		resourceId: '',
	});
	const updatedIssueAriId = issueId ?? defautIssueAri;
	/* End of code which should not be used for any other thing
	 */
	const variables: Variables = useMemo(() => {
		const shouldUseIssueKey = !issueId;
		const issueInput = shouldUseIssueKey ? { issueKey } : { issueId };
		return {
			transitionId,
			issueId: updatedIssueAriId,
			issueKey,
			cloudId,
			contextId: siteContextARI,
			moveGicFieldToDecomp: ff('modern-issue-transition-fields-rollout-batch-2_bremb'),
			shouldUseIssueKey: !issueId,
			issueInput,
		};
	}, [transitionId, updatedIssueAriId, issueKey, cloudId, siteContextARI, issueId]);

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint<
		typeof asyncIssueTransitionModal
	>(asyncIssueTransitionModal, variables);

	useSubscribeOpenIssueTransitionModalPubSub();

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (isModalOpen && transitionId && (issueKey || issueId)) {
			entryPointActions.load();
		} else {
			entryPointActions.unload();
		}
	}, [entryPointActions, isModalOpen, issueKey, issueId, transitionId]);

	return (
		<ModalEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="async.jira.issue-transition-modal"
			packageName="jiraIssueTransitionModal"
			teamName="Gryffindor"
			runtimeProps={runtimeProps}
			entryPointActions={entryPointActions}
			errorFallback="flag"
		/>
	);
};
